import { Component, Input, OnInit } from '@angular/core';
import Editor from 'ckeditor5-custom-build';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-editor-rich-text',
  templateUrl: './editor-rich-text.component.html',
  styleUrls: ['./editor-rich-text.component.scss'],
})
export class EditorRichTextComponent implements OnInit {
  configDefault = {
    placeholder: 'Veuillez saisir le contenu...',
  };
  @Input() title = 'Définir le contenu';
  @Input() config = this.configDefault;
  @Input() content: string;
  @Input() withName = false;
  name: string | undefined;
  Editor = Editor;
  onClose: Subject<
    | {
        name: string | undefined;
        content: string;
      }
    | undefined
  >;

  constructor(private bsModalRef: BsModalRef, private toastr: ToastrService) {
    // Nada
  }

  ngOnInit(): void {
    this.onClose = new Subject<
      | {
          name: string | undefined;
          content: string;
        }
      | undefined
    >();
  }

  hideModal() {
    this.onClose.next(undefined);
    this.bsModalRef.hide();
  }

  enabledValidation() {
    if (this.withName) {
      return this.name && this.name.length > 0;
    } else {
      return true;
    }
  }

  validation() {
    if (this.content.length > 1000000) {
      this.toastr.error(
        'Le contenu du document est trop volumineux ! Veuillez réduire la taille des images.',
        'Erreur',
        { extendedTimeOut: 5000 },
      );
    } else {
      if (this.withName) {
        if (this.name) {
          this.onClose.next({
            name: this.name,
            content: this.content,
          });
          this.hideModal();
        }
      } else {
        this.onClose.next({
          name: undefined,
          content: this.content,
        });
        this.hideModal();
      }
    }
  }

  isInvalidName() {
    return !this.name || this.name.length === 0;
  }
}
